var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c("divider", {
            staticClass: "text-container",
            attrs: { label: "Visualizar documento" }
          })
        ],
        1
      ),
      _c("visualizar-documentos", {
        attrs: { documento: _vm.documentoAssinatura, bytes: _vm.bytes }
      }),
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "el-row",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "default", name: "voltar" },
                  on: { click: _vm.goToListagem }
                },
                [
                  _c("span", { staticClass: "center" }, [
                    _c("i", { staticClass: "fa fa-chevron-left" }),
                    _c("b", [_vm._v("  Voltar")])
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0402808f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0402808f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/assinatura/VisualizarDocumento.vue
// module id = null
// module chunks = 